/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  ClaimOverwolfRewardResponse,
  CloseOWActiveMatchBody,
  CreateElectronInstallSnapshotRequestBody,
  CreateElectronInstallSnapshotResponse,
  CreateOWInfoStateBody,
  CreateOWLogRequestBody,
  CreateOWUserEventBody,
  CreateOverwolfGameBody,
  CreateOverwolfGameImages,
  FormError,
  GameIconsResponse,
  GenerateEventSubmissionTokenResponse,
  GetAllOverwolfEventTypesResponse,
  GetOverwolfEventMappingsResponse,
  GetOverwolfEventTypesResponse,
  GetOverwolfEventTypesSort,
  GetOverwolfGamesResponse,
  GetOverwolfQuestsResponse,
  GetOverwolfQuestsSort,
  GetOverwolfXPResponse,
  GetUserStatsResponse,
  GetUserSummaryResponse,
  OWEventType,
  OWEventTypeBody,
  OWEventTypeResponse,
  OWGame,
  OWGameResponse,
  OWQuestBody,
  OWQuestResponse,
  OWReward,
  OverwolfLauncherGameIdsResponse,
  SearchEnhancedGamesResponse,
  SortOrder,
  UpdateEnhancedGameInfoBody,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    ClaimOverwolfRewardResponseFromJSON,
    ClaimOverwolfRewardResponseToJSON,
    CloseOWActiveMatchBodyFromJSON,
    CloseOWActiveMatchBodyToJSON,
    CreateElectronInstallSnapshotRequestBodyFromJSON,
    CreateElectronInstallSnapshotRequestBodyToJSON,
    CreateElectronInstallSnapshotResponseFromJSON,
    CreateElectronInstallSnapshotResponseToJSON,
    CreateOWInfoStateBodyFromJSON,
    CreateOWInfoStateBodyToJSON,
    CreateOWLogRequestBodyFromJSON,
    CreateOWLogRequestBodyToJSON,
    CreateOWUserEventBodyFromJSON,
    CreateOWUserEventBodyToJSON,
    CreateOverwolfGameBodyFromJSON,
    CreateOverwolfGameBodyToJSON,
    CreateOverwolfGameImagesFromJSON,
    CreateOverwolfGameImagesToJSON,
    FormErrorFromJSON,
    FormErrorToJSON,
    GameIconsResponseFromJSON,
    GameIconsResponseToJSON,
    GenerateEventSubmissionTokenResponseFromJSON,
    GenerateEventSubmissionTokenResponseToJSON,
    GetAllOverwolfEventTypesResponseFromJSON,
    GetAllOverwolfEventTypesResponseToJSON,
    GetOverwolfEventMappingsResponseFromJSON,
    GetOverwolfEventMappingsResponseToJSON,
    GetOverwolfEventTypesResponseFromJSON,
    GetOverwolfEventTypesResponseToJSON,
    GetOverwolfEventTypesSortFromJSON,
    GetOverwolfEventTypesSortToJSON,
    GetOverwolfGamesResponseFromJSON,
    GetOverwolfGamesResponseToJSON,
    GetOverwolfQuestsResponseFromJSON,
    GetOverwolfQuestsResponseToJSON,
    GetOverwolfQuestsSortFromJSON,
    GetOverwolfQuestsSortToJSON,
    GetOverwolfXPResponseFromJSON,
    GetOverwolfXPResponseToJSON,
    GetUserStatsResponseFromJSON,
    GetUserStatsResponseToJSON,
    GetUserSummaryResponseFromJSON,
    GetUserSummaryResponseToJSON,
    OWEventTypeFromJSON,
    OWEventTypeToJSON,
    OWEventTypeBodyFromJSON,
    OWEventTypeBodyToJSON,
    OWEventTypeResponseFromJSON,
    OWEventTypeResponseToJSON,
    OWGameFromJSON,
    OWGameToJSON,
    OWGameResponseFromJSON,
    OWGameResponseToJSON,
    OWQuestBodyFromJSON,
    OWQuestBodyToJSON,
    OWQuestResponseFromJSON,
    OWQuestResponseToJSON,
    OWRewardFromJSON,
    OWRewardToJSON,
    OverwolfLauncherGameIdsResponseFromJSON,
    OverwolfLauncherGameIdsResponseToJSON,
    SearchEnhancedGamesResponseFromJSON,
    SearchEnhancedGamesResponseToJSON,
    SortOrderFromJSON,
    SortOrderToJSON,
    UpdateEnhancedGameInfoBodyFromJSON,
    UpdateEnhancedGameInfoBodyToJSON,
} from '../models/index';

export interface CreateOverwolfClaimRewardRequest {
    rewardId: string;
    rewardConfigId?: string;
    gameId?: string;
    body?: object;
}

export interface CreateOverwolfCloseActiveMatchRequest {
    closeOWActiveMatchBody?: CloseOWActiveMatchBody;
}

export interface CreateOverwolfEnhancedGameInfoRequest {
    updateEnhancedGameInfoBody: UpdateEnhancedGameInfoBody;
}

export interface CreateOverwolfEventRequest {
    createOWLogRequestBody?: CreateOWLogRequestBody;
}

export interface CreateOverwolfEventSubmissionTokenIdRequest {
    id: string;
}

export interface CreateOverwolfEventTypeRequest {
    oWEventTypeBody?: OWEventTypeBody;
}

export interface CreateOverwolfGamesRequest {
    createOverwolfGameBody?: CreateOverwolfGameBody;
}

export interface CreateOverwolfInfoStateRequest {
    createOWInfoStateBody?: CreateOWInfoStateBody;
}

export interface CreateOverwolfInstallSnapshotRequest {
    createElectronInstallSnapshotRequestBody: CreateElectronInstallSnapshotRequestBody;
}

export interface CreateOverwolfNpmPackageEventRequest {
    createOWLogRequestBody?: CreateOWLogRequestBody;
}

export interface CreateOverwolfQuestRequest {
    oWQuestBody?: OWQuestBody;
}

export interface CreateOverwolfUserEventsRequest {
    createOWUserEventBody?: CreateOWUserEventBody;
}

export interface DeleteOverwolfEventTypeIdRequest {
    id: string;
}

export interface DeleteOverwolfQuestIdRequest {
    id: string;
}

export interface GetOverwolfAvailableEventTypesIdRequest {
    id: string;
}

export interface GetOverwolfEnhancedGameInfoIdRequest {
    id: string;
}

export interface GetOverwolfEnhancedGamesSearchRequest {
    search?: string;
    gameId?: string;
    seoEnabled?: GetOverwolfEnhancedGamesSearchSeoEnabledEnum;
    timeTrackedGame?: GetOverwolfEnhancedGamesSearchTimeTrackedGameEnum;
    hasEvents?: GetOverwolfEnhancedGamesSearchHasEventsEnum;
    limit?: number;
    offset?: number;
}

export interface GetOverwolfEventTypeIdRequest {
    id: string;
}

export interface GetOverwolfEventTypesRequest {
    search?: string;
    game?: string;
    sort?: GetOverwolfEventTypesSort;
    order?: SortOrder;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetOverwolfGamesRequest {
    search?: string;
    seoFilter?: GetOverwolfGamesSeoFilterEnum;
    eventFilter?: GetOverwolfGamesEventFilterEnum;
    steamFilter?: GetOverwolfGamesSteamFilterEnum;
    categoryFilter?: string;
    tournamentFilter?: GetOverwolfGamesTournamentFilterEnum;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetOverwolfGamesBySlugSlugRequest {
    slug: string;
}

export interface GetOverwolfGamesIdRequest {
    id: string;
}

export interface GetOverwolfGamesIdRewardsRequest {
    id: string;
}

export interface GetOverwolfQuestsRequest {
    game?: string;
    isActive?: string;
    search?: string;
    sort?: GetOverwolfQuestsSort;
    order?: SortOrder;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetOverwolfUserStatsRequest {
    gameId?: string;
    rewardId?: string;
    rewardCategory?: GetOverwolfUserStatsRewardCategoryEnum;
}

export interface GetOverwolfUserSummaryRequest {
    period?: GetOverwolfUserSummaryPeriodEnum;
}

export interface GetOverwolfXpRequest {
    subject: GetOverwolfXpSubjectEnum;
    overwolfRewardId?: string;
    gameId?: string;
    notes?: string;
}

export interface UpdateOverwolfEventTypeIdRequest {
    id: string;
    oWEventTypeBody?: OWEventTypeBody;
}

export interface UpdateOverwolfGamesIdRequest {
    id: string;
    createOverwolfGameBody?: CreateOverwolfGameBody;
}

export interface UpdateOverwolfGamesIdImagesRequest {
    id: string;
    createOverwolfGameImages?: CreateOverwolfGameImages;
}

export interface UpdateOverwolfQuestIdRequest {
    id: string;
    oWQuestBody?: OWQuestBody;
}

/**
 * OverwolfApi - interface
 * 
 * @export
 * @interface OverwolfApiInterface
 */
export interface OverwolfApiInterface {
    /**
     * Claims an Overwolf completed reward.
     * @param {string} rewardId 
     * @param {string} [rewardConfigId] 
     * @param {string} [gameId] 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    createOverwolfClaimRewardRaw(requestParameters: CreateOverwolfClaimRewardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimOverwolfRewardResponse>>;

    /**
     * Claims an Overwolf completed reward.
     */
    createOverwolfClaimReward(requestParameters: CreateOverwolfClaimRewardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimOverwolfRewardResponse>;

    /**
     * Client-reported game exit. Closes the user\'s active match bracket for the game immediately (clears the Redis bracket flag + finalizes the open MatchContext) instead of waiting out the 90-minute bracket TTL. Makes match boundaries authoritative so a stale match/verdict can\'t linger into the next match. Idempotent — a no-op when no bracket is open. 
     * @param {CloseOWActiveMatchBody} [closeOWActiveMatchBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    createOverwolfCloseActiveMatchRaw(requestParameters: CreateOverwolfCloseActiveMatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Client-reported game exit. Closes the user\'s active match bracket for the game immediately (clears the Redis bracket flag + finalizes the open MatchContext) instead of waiting out the 90-minute bracket TTL. Makes match boundaries authoritative so a stale match/verdict can\'t linger into the next match. Idempotent — a no-op when no bracket is open. 
     */
    createOverwolfCloseActiveMatch(requestParameters: CreateOverwolfCloseActiveMatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Import or update enhanced game data from Steam. Creates new game if doesn\'t exist.
     * @param {UpdateEnhancedGameInfoBody} updateEnhancedGameInfoBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    createOverwolfEnhancedGameInfoRaw(requestParameters: CreateOverwolfEnhancedGameInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OWGameResponse>>;

    /**
     * Import or update enhanced game data from Steam. Creates new game if doesn\'t exist.
     */
    createOverwolfEnhancedGameInfo(requestParameters: CreateOverwolfEnhancedGameInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OWGameResponse>;

    /**
     * Creates a new Overwolf event log.
     * @param {CreateOWLogRequestBody} [createOWLogRequestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    createOverwolfEventRaw(requestParameters: CreateOverwolfEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Creates a new Overwolf event log.
     */
    createOverwolfEvent(requestParameters: CreateOverwolfEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Generate a new auth token to allow event submissions to user\'s profile.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    createOverwolfEventSubmissionTokenIdRaw(requestParameters: CreateOverwolfEventSubmissionTokenIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenerateEventSubmissionTokenResponse>>;

    /**
     * Generate a new auth token to allow event submissions to user\'s profile.
     */
    createOverwolfEventSubmissionTokenId(requestParameters: CreateOverwolfEventSubmissionTokenIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenerateEventSubmissionTokenResponse>;

    /**
     * Used to create new Overwolf event type
     * @param {OWEventTypeBody} [oWEventTypeBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    createOverwolfEventTypeRaw(requestParameters: CreateOverwolfEventTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OWEventTypeResponse>>;

    /**
     * Used to create new Overwolf event type
     */
    createOverwolfEventType(requestParameters: CreateOverwolfEventTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OWEventTypeResponse>;

    /**
     * Used to create new Overwolf game
     * @param {CreateOverwolfGameBody} [createOverwolfGameBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    createOverwolfGamesRaw(requestParameters: CreateOverwolfGamesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OWGame>>;

    /**
     * Used to create new Overwolf game
     */
    createOverwolfGames(requestParameters: CreateOverwolfGamesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OWGame>;

    /**
     * A manual trigger of overwolf state returned from their getInfo() function.
     * @param {CreateOWInfoStateBody} [createOWInfoStateBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    createOverwolfInfoStateRaw(requestParameters: CreateOverwolfInfoStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * A manual trigger of overwolf state returned from their getInfo() function.
     */
    createOverwolfInfoState(requestParameters: CreateOverwolfInfoStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Record an Electron install\'s GEP-package state snapshot
     * @param {CreateElectronInstallSnapshotRequestBody} createElectronInstallSnapshotRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    createOverwolfInstallSnapshotRaw(requestParameters: CreateOverwolfInstallSnapshotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateElectronInstallSnapshotResponse>>;

    /**
     * Record an Electron install\'s GEP-package state snapshot
     */
    createOverwolfInstallSnapshot(requestParameters: CreateOverwolfInstallSnapshotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateElectronInstallSnapshotResponse>;

    /**
     * Creates a new Overwolf event log for partners using our npm package.
     * @param {CreateOWLogRequestBody} [createOWLogRequestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    createOverwolfNpmPackageEventRaw(requestParameters: CreateOverwolfNpmPackageEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Creates a new Overwolf event log for partners using our npm package.
     */
    createOverwolfNpmPackageEvent(requestParameters: CreateOverwolfNpmPackageEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used to create new Overwolf quest (OWReward doc)
     * @param {OWQuestBody} [oWQuestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    createOverwolfQuestRaw(requestParameters: CreateOverwolfQuestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OWQuestResponse>>;

    /**
     * Used to create new Overwolf quest (OWReward doc)
     */
    createOverwolfQuest(requestParameters: CreateOverwolfQuestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OWQuestResponse>;

    /**
     * Creates a new Overwolf user event log.
     * @param {CreateOWUserEventBody} [createOWUserEventBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    createOverwolfUserEventsRaw(requestParameters: CreateOverwolfUserEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Creates a new Overwolf user event log.
     */
    createOverwolfUserEvents(requestParameters: CreateOverwolfUserEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Remove a specific Overwolf event type and update the game doc if necessary
     * @param {string} id ID of the event type to remove
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    deleteOverwolfEventTypeIdRaw(requestParameters: DeleteOverwolfEventTypeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Remove a specific Overwolf event type and update the game doc if necessary
     */
    deleteOverwolfEventTypeId(requestParameters: DeleteOverwolfEventTypeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Remove a specific Overwolf quest, with all corresponding userStats
     * @param {string} id ID of the quest to remove
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    deleteOverwolfQuestIdRaw(requestParameters: DeleteOverwolfQuestIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Remove a specific Overwolf quest, with all corresponding userStats
     */
    deleteOverwolfQuestId(requestParameters: DeleteOverwolfQuestIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Fetch available event types for a specific game
     * @param {string} id The ID of the game to retrieve available event types for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    getOverwolfAvailableEventTypesIdRaw(requestParameters: GetOverwolfAvailableEventTypesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OWEventTypeResponse>>>;

    /**
     * Fetch available event types for a specific game
     */
    getOverwolfAvailableEventTypesId(requestParameters: GetOverwolfAvailableEventTypesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OWEventTypeResponse>>;

    /**
     * Get list of all dual games
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    getOverwolfDualGamesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OWGameResponse>>>;

    /**
     * Get list of all dual games
     */
    getOverwolfDualGames(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OWGameResponse>>;

    /**
     * Get enhanced game information including all original and Steam fields for Admin and front-end display
     * @param {string} id The game\&#39;s Overwolf game id (either id form), or its MongoDB id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    getOverwolfEnhancedGameInfoIdRaw(requestParameters: GetOverwolfEnhancedGameInfoIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OWGameResponse>>;

    /**
     * Get enhanced game information including all original and Steam fields for Admin and front-end display
     */
    getOverwolfEnhancedGameInfoId(requestParameters: GetOverwolfEnhancedGameInfoIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OWGameResponse>;

    /**
     * Search for games with enhanced features and SEO pages
     * @param {string} [search] Search term for game name
     * @param {string} [gameId] Overwolf game ID for exact match (e.g., \&quot;21216\&quot; for CS2)
     * @param {'true' | 'false'} [seoEnabled] Filter by SEO enabled games. Pass \&quot;true\&quot; or \&quot;false\&quot; as a string — handler compares via &#x3D;&#x3D;&#x3D; \&quot;true\&quot;.
     * @param {'true' | 'false'} [timeTrackedGame] Filter by time tracking support. Pass \&quot;true\&quot; or \&quot;false\&quot;.
     * @param {'true' | 'false'} [hasEvents] Filter by event support. Pass \&quot;true\&quot; or \&quot;false\&quot;.
     * @param {number} [limit] Number of results to return
     * @param {number} [offset] Offset for pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    getOverwolfEnhancedGamesSearchRaw(requestParameters: GetOverwolfEnhancedGamesSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchEnhancedGamesResponse>>;

    /**
     * Search for games with enhanced features and SEO pages
     */
    getOverwolfEnhancedGamesSearch(requestParameters: GetOverwolfEnhancedGamesSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchEnhancedGamesResponse>;

    /**
     * Get list of all game event mappings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    getOverwolfEventMappingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOverwolfEventMappingsResponse>>;

    /**
     * Get list of all game event mappings
     */
    getOverwolfEventMappings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOverwolfEventMappingsResponse>;

    /**
     * Get a single event type by ID
     * @param {string} id The ID of the event type to retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    getOverwolfEventTypeIdRaw(requestParameters: GetOverwolfEventTypeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OWEventType>>;

    /**
     * Get a single event type by ID
     */
    getOverwolfEventTypeId(requestParameters: GetOverwolfEventTypeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OWEventType>;

    /**
     * Get list of all event types
     * @param {string} [search] 
     * @param {string} [game] 
     * @param {GetOverwolfEventTypesSort} [sort] 
     * @param {SortOrder} [order] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    getOverwolfEventTypesRaw(requestParameters: GetOverwolfEventTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOverwolfEventTypesResponse>>;

    /**
     * Get list of all event types
     */
    getOverwolfEventTypes(requestParameters: GetOverwolfEventTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOverwolfEventTypesResponse>;

    /**
     * Get list of all event types without pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    getOverwolfEventTypesAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAllOverwolfEventTypesResponse>>;

    /**
     * Get list of all event types without pagination
     */
    getOverwolfEventTypesAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAllOverwolfEventTypesResponse>;

    /**
     * Returns a lightweight name→iconUrl entry for every game/category we can icon: platform box art first (Twitch Helix box_art_url / Kick category thumbnail, resolved by streamed gameId then by name for Drop.games[] strings with no recorded id), with curated OWGame catalog assets as the fallback for names neither platform resolves. Backs the Drop-In directory\'s game-icon lookup. The assembled map is cached in GCS for 1 day and at the edge for an hour. 
     * @summary name → iconUrl for ALL games + streamed categories (Drop-In game-icon resolution)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    getOverwolfGameIconsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GameIconsResponse>>;

    /**
     * Returns a lightweight name→iconUrl entry for every game/category we can icon: platform box art first (Twitch Helix box_art_url / Kick category thumbnail, resolved by streamed gameId then by name for Drop.games[] strings with no recorded id), with curated OWGame catalog assets as the fallback for names neither platform resolves. Backs the Drop-In directory\'s game-icon lookup. The assembled map is cached in GCS for 1 day and at the edge for an hour. 
     * name → iconUrl for ALL games + streamed categories (Drop-In game-icon resolution)
     */
    getOverwolfGameIcons(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GameIconsResponse>;

    /**
     * Get list of all games
     * @param {string} [search] 
     * @param {'all' | 'enabled' | 'disabled'} [seoFilter] 
     * @param {'all' | 'events' | 'time'} [eventFilter] 
     * @param {'all' | 'has' | 'none'} [steamFilter] 
     * @param {string} [categoryFilter] 
     * @param {'all' | 'supported' | 'unsupported'} [tournamentFilter] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    getOverwolfGamesRaw(requestParameters: GetOverwolfGamesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOverwolfGamesResponse>>;

    /**
     * Get list of all games
     */
    getOverwolfGames(requestParameters: GetOverwolfGamesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOverwolfGamesResponse>;

    /**
     * Get game information by URL slug for public game pages
     * @param {string} slug The game\&#39;s URL slug, or its numeric Overwolf game id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    getOverwolfGamesBySlugSlugRaw(requestParameters: GetOverwolfGamesBySlugSlugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OWGameResponse>>;

    /**
     * Get game information by URL slug for public game pages
     */
    getOverwolfGamesBySlugSlug(requestParameters: GetOverwolfGamesBySlugSlugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OWGameResponse>;

    /**
     * Retrieves Overwolf game data.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    getOverwolfGamesIdRaw(requestParameters: GetOverwolfGamesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OWGame>>;

    /**
     * Retrieves Overwolf game data.
     */
    getOverwolfGamesId(requestParameters: GetOverwolfGamesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OWGame>;

    /**
     * Retrieves Overwolf rewards for a specific game.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    getOverwolfGamesIdRewardsRaw(requestParameters: GetOverwolfGamesIdRewardsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OWReward>>>;

    /**
     * Retrieves Overwolf rewards for a specific game.
     */
    getOverwolfGamesIdRewards(requestParameters: GetOverwolfGamesIdRewardsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OWReward>>;

    /**
     * Returns the Overwolf gameIds of platform launchers (Battle.net, Epic, Steam, etc.). The renderer uses this to suppress launcher-state flicker when a non-launcher game is the active session.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    getOverwolfGamesLaunchersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OverwolfLauncherGameIdsResponse>>;

    /**
     * Returns the Overwolf gameIds of platform launchers (Battle.net, Epic, Steam, etc.). The renderer uses this to suppress launcher-state flicker when a non-launcher game is the active session.
     */
    getOverwolfGamesLaunchers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OverwolfLauncherGameIdsResponse>;

    /**
     * Get list of all event types
     * @param {string} [game] ID of the game to filter quests by
     * @param {string} [isActive] Filter by active or inactive quests
     * @param {string} [search] 
     * @param {GetOverwolfQuestsSort} [sort] 
     * @param {SortOrder} [order] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    getOverwolfQuestsRaw(requestParameters: GetOverwolfQuestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOverwolfQuestsResponse>>;

    /**
     * Get list of all event types
     */
    getOverwolfQuests(requestParameters: GetOverwolfQuestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOverwolfQuestsResponse>;

    /**
     * Retrieves Overwolf user stats.
     * @param {string} [gameId] Optional Overwolf game ID to filter user stats.
     * @param {string} [rewardId] Optional reward ID to filter user stats.
     * @param {'EVENT' | 'TIME'} [rewardCategory] Optional reward category (\&quot;EVENT\&quot; or \&quot;TIME\&quot;) to filter user stats.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    getOverwolfUserStatsRaw(requestParameters: GetOverwolfUserStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUserStatsResponse>>;

    /**
     * Retrieves Overwolf user stats.
     */
    getOverwolfUserStats(requestParameters: GetOverwolfUserStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUserStatsResponse>;

    /**
     * Gets the total xp, time and played games of the current user.
     * @param {'today' | 'weekly' | 'monthly' | 'allTime'} [period] Time period to filter summary data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    getOverwolfUserSummaryRaw(requestParameters: GetOverwolfUserSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUserSummaryResponse>>;

    /**
     * Gets the total xp, time and played games of the current user.
     */
    getOverwolfUserSummary(requestParameters: GetOverwolfUserSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUserSummaryResponse>;

    /**
     * Retrieves Overwolf-related account experience transactions for a user.
     * @param {'OVERWOLF_TIME_REWARD' | 'OVERWOLF_EVENT_REWARD' | 'OVERWOLF_TIME_QUEST_REWARD'} subject The subject of the transaction. Must be one of the specified enum values.
     * @param {string} [overwolfRewardId] Optional Overwolf reward ID to filter transactions.
     * @param {string} [gameId] Optional game ID to filter transactions for a specific game.
     * @param {string} [notes] Optional notes to filter transactions.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    getOverwolfXpRaw(requestParameters: GetOverwolfXpRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOverwolfXPResponse>>;

    /**
     * Retrieves Overwolf-related account experience transactions for a user.
     */
    getOverwolfXp(requestParameters: GetOverwolfXpRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOverwolfXPResponse>;

    /**
     * Used to update existing Overwolf event type
     * @param {string} id 
     * @param {OWEventTypeBody} [oWEventTypeBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    updateOverwolfEventTypeIdRaw(requestParameters: UpdateOverwolfEventTypeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OWEventTypeResponse>>;

    /**
     * Used to update existing Overwolf event type
     */
    updateOverwolfEventTypeId(requestParameters: UpdateOverwolfEventTypeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OWEventTypeResponse>;

    /**
     * Used to update existing Overwolf game
     * @param {string} id 
     * @param {CreateOverwolfGameBody} [createOverwolfGameBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    updateOverwolfGamesIdRaw(requestParameters: UpdateOverwolfGamesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used to update existing Overwolf game
     */
    updateOverwolfGamesId(requestParameters: UpdateOverwolfGamesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used to update existing Overwolf game images
     * @param {string} id 
     * @param {CreateOverwolfGameImages} [createOverwolfGameImages] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    updateOverwolfGamesIdImagesRaw(requestParameters: UpdateOverwolfGamesIdImagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used to update existing Overwolf game images
     */
    updateOverwolfGamesIdImages(requestParameters: UpdateOverwolfGamesIdImagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used to update existing Overwolf quest (OWReward doc)
     * @param {string} id 
     * @param {OWQuestBody} [oWQuestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    updateOverwolfQuestIdRaw(requestParameters: UpdateOverwolfQuestIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OWQuestResponse>>;

    /**
     * Used to update existing Overwolf quest (OWReward doc)
     */
    updateOverwolfQuestId(requestParameters: UpdateOverwolfQuestIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OWQuestResponse>;

    /**
     * Dismiss the weekly limit feedback for the user\'s Overwolf reward stats.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    updateOverwolfWeeklyLimitFeedbackRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Dismiss the weekly limit feedback for the user\'s Overwolf reward stats.
     */
    updateOverwolfWeeklyLimitFeedback(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class OverwolfApi extends runtime.BaseAPI implements OverwolfApiInterface {

    /**
     * Claims an Overwolf completed reward.
     */
    async createOverwolfClaimRewardRaw(requestParameters: CreateOverwolfClaimRewardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimOverwolfRewardResponse>> {
        if (requestParameters['rewardId'] == null) {
            throw new runtime.RequiredError(
                'rewardId',
                'Required parameter "rewardId" was null or undefined when calling createOverwolfClaimReward().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['rewardId'] != null) {
            queryParameters['rewardId'] = requestParameters['rewardId'];
        }

        if (requestParameters['rewardConfigId'] != null) {
            queryParameters['rewardConfigId'] = requestParameters['rewardConfigId'];
        }

        if (requestParameters['gameId'] != null) {
            queryParameters['gameId'] = requestParameters['gameId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/overwolf/claim-reward`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimOverwolfRewardResponseFromJSON(jsonValue));
    }

    /**
     * Claims an Overwolf completed reward.
     */
    async createOverwolfClaimReward(requestParameters: CreateOverwolfClaimRewardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimOverwolfRewardResponse> {
        const response = await this.createOverwolfClaimRewardRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Client-reported game exit. Closes the user\'s active match bracket for the game immediately (clears the Redis bracket flag + finalizes the open MatchContext) instead of waiting out the 90-minute bracket TTL. Makes match boundaries authoritative so a stale match/verdict can\'t linger into the next match. Idempotent — a no-op when no bracket is open. 
     */
    async createOverwolfCloseActiveMatchRaw(requestParameters: CreateOverwolfCloseActiveMatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/overwolf/close-active-match`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CloseOWActiveMatchBodyToJSON(requestParameters['closeOWActiveMatchBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Client-reported game exit. Closes the user\'s active match bracket for the game immediately (clears the Redis bracket flag + finalizes the open MatchContext) instead of waiting out the 90-minute bracket TTL. Makes match boundaries authoritative so a stale match/verdict can\'t linger into the next match. Idempotent — a no-op when no bracket is open. 
     */
    async createOverwolfCloseActiveMatch(requestParameters: CreateOverwolfCloseActiveMatchRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createOverwolfCloseActiveMatchRaw(requestParameters, initOverrides);
    }

    /**
     * Import or update enhanced game data from Steam. Creates new game if doesn\'t exist.
     */
    async createOverwolfEnhancedGameInfoRaw(requestParameters: CreateOverwolfEnhancedGameInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OWGameResponse>> {
        if (requestParameters['updateEnhancedGameInfoBody'] == null) {
            throw new runtime.RequiredError(
                'updateEnhancedGameInfoBody',
                'Required parameter "updateEnhancedGameInfoBody" was null or undefined when calling createOverwolfEnhancedGameInfo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/overwolf/enhanced-game-info`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateEnhancedGameInfoBodyToJSON(requestParameters['updateEnhancedGameInfoBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OWGameResponseFromJSON(jsonValue));
    }

    /**
     * Import or update enhanced game data from Steam. Creates new game if doesn\'t exist.
     */
    async createOverwolfEnhancedGameInfo(requestParameters: CreateOverwolfEnhancedGameInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OWGameResponse> {
        const response = await this.createOverwolfEnhancedGameInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new Overwolf event log.
     */
    async createOverwolfEventRaw(requestParameters: CreateOverwolfEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/overwolf/event`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOWLogRequestBodyToJSON(requestParameters['createOWLogRequestBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Creates a new Overwolf event log.
     */
    async createOverwolfEvent(requestParameters: CreateOverwolfEventRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createOverwolfEventRaw(requestParameters, initOverrides);
    }

    /**
     * Generate a new auth token to allow event submissions to user\'s profile.
     */
    async createOverwolfEventSubmissionTokenIdRaw(requestParameters: CreateOverwolfEventSubmissionTokenIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenerateEventSubmissionTokenResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createOverwolfEventSubmissionTokenId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/overwolf/event-submission-token/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GenerateEventSubmissionTokenResponseFromJSON(jsonValue));
    }

    /**
     * Generate a new auth token to allow event submissions to user\'s profile.
     */
    async createOverwolfEventSubmissionTokenId(requestParameters: CreateOverwolfEventSubmissionTokenIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenerateEventSubmissionTokenResponse> {
        const response = await this.createOverwolfEventSubmissionTokenIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to create new Overwolf event type
     */
    async createOverwolfEventTypeRaw(requestParameters: CreateOverwolfEventTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OWEventTypeResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/overwolf/event-type`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OWEventTypeBodyToJSON(requestParameters['oWEventTypeBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OWEventTypeResponseFromJSON(jsonValue));
    }

    /**
     * Used to create new Overwolf event type
     */
    async createOverwolfEventType(requestParameters: CreateOverwolfEventTypeRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OWEventTypeResponse> {
        const response = await this.createOverwolfEventTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to create new Overwolf game
     */
    async createOverwolfGamesRaw(requestParameters: CreateOverwolfGamesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OWGame>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/overwolf/games`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOverwolfGameBodyToJSON(requestParameters['createOverwolfGameBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OWGameFromJSON(jsonValue));
    }

    /**
     * Used to create new Overwolf game
     */
    async createOverwolfGames(requestParameters: CreateOverwolfGamesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OWGame> {
        const response = await this.createOverwolfGamesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * A manual trigger of overwolf state returned from their getInfo() function.
     */
    async createOverwolfInfoStateRaw(requestParameters: CreateOverwolfInfoStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/overwolf/info-state`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOWInfoStateBodyToJSON(requestParameters['createOWInfoStateBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * A manual trigger of overwolf state returned from their getInfo() function.
     */
    async createOverwolfInfoState(requestParameters: CreateOverwolfInfoStateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createOverwolfInfoStateRaw(requestParameters, initOverrides);
    }

    /**
     * Record an Electron install\'s GEP-package state snapshot
     */
    async createOverwolfInstallSnapshotRaw(requestParameters: CreateOverwolfInstallSnapshotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateElectronInstallSnapshotResponse>> {
        if (requestParameters['createElectronInstallSnapshotRequestBody'] == null) {
            throw new runtime.RequiredError(
                'createElectronInstallSnapshotRequestBody',
                'Required parameter "createElectronInstallSnapshotRequestBody" was null or undefined when calling createOverwolfInstallSnapshot().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/overwolf/install-snapshot`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateElectronInstallSnapshotRequestBodyToJSON(requestParameters['createElectronInstallSnapshotRequestBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateElectronInstallSnapshotResponseFromJSON(jsonValue));
    }

    /**
     * Record an Electron install\'s GEP-package state snapshot
     */
    async createOverwolfInstallSnapshot(requestParameters: CreateOverwolfInstallSnapshotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateElectronInstallSnapshotResponse> {
        const response = await this.createOverwolfInstallSnapshotRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new Overwolf event log for partners using our npm package.
     */
    async createOverwolfNpmPackageEventRaw(requestParameters: CreateOverwolfNpmPackageEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/overwolf/npm-package/event`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOWLogRequestBodyToJSON(requestParameters['createOWLogRequestBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Creates a new Overwolf event log for partners using our npm package.
     */
    async createOverwolfNpmPackageEvent(requestParameters: CreateOverwolfNpmPackageEventRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createOverwolfNpmPackageEventRaw(requestParameters, initOverrides);
    }

    /**
     * Used to create new Overwolf quest (OWReward doc)
     */
    async createOverwolfQuestRaw(requestParameters: CreateOverwolfQuestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OWQuestResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/overwolf/quest`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OWQuestBodyToJSON(requestParameters['oWQuestBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OWQuestResponseFromJSON(jsonValue));
    }

    /**
     * Used to create new Overwolf quest (OWReward doc)
     */
    async createOverwolfQuest(requestParameters: CreateOverwolfQuestRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OWQuestResponse> {
        const response = await this.createOverwolfQuestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new Overwolf user event log.
     */
    async createOverwolfUserEventsRaw(requestParameters: CreateOverwolfUserEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/overwolf/user-events`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOWUserEventBodyToJSON(requestParameters['createOWUserEventBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Creates a new Overwolf user event log.
     */
    async createOverwolfUserEvents(requestParameters: CreateOverwolfUserEventsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createOverwolfUserEventsRaw(requestParameters, initOverrides);
    }

    /**
     * Remove a specific Overwolf event type and update the game doc if necessary
     */
    async deleteOverwolfEventTypeIdRaw(requestParameters: DeleteOverwolfEventTypeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteOverwolfEventTypeId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/overwolf/event-type/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove a specific Overwolf event type and update the game doc if necessary
     */
    async deleteOverwolfEventTypeId(requestParameters: DeleteOverwolfEventTypeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteOverwolfEventTypeIdRaw(requestParameters, initOverrides);
    }

    /**
     * Remove a specific Overwolf quest, with all corresponding userStats
     */
    async deleteOverwolfQuestIdRaw(requestParameters: DeleteOverwolfQuestIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteOverwolfQuestId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/overwolf/quest/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove a specific Overwolf quest, with all corresponding userStats
     */
    async deleteOverwolfQuestId(requestParameters: DeleteOverwolfQuestIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteOverwolfQuestIdRaw(requestParameters, initOverrides);
    }

    /**
     * Fetch available event types for a specific game
     */
    async getOverwolfAvailableEventTypesIdRaw(requestParameters: GetOverwolfAvailableEventTypesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OWEventTypeResponse>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getOverwolfAvailableEventTypesId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/overwolf/available-event-types/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OWEventTypeResponseFromJSON));
    }

    /**
     * Fetch available event types for a specific game
     */
    async getOverwolfAvailableEventTypesId(requestParameters: GetOverwolfAvailableEventTypesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OWEventTypeResponse>> {
        const response = await this.getOverwolfAvailableEventTypesIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get list of all dual games
     */
    async getOverwolfDualGamesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OWGameResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Optional", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/overwolf/dual-games`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OWGameResponseFromJSON));
    }

    /**
     * Get list of all dual games
     */
    async getOverwolfDualGames(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OWGameResponse>> {
        const response = await this.getOverwolfDualGamesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get enhanced game information including all original and Steam fields for Admin and front-end display
     */
    async getOverwolfEnhancedGameInfoIdRaw(requestParameters: GetOverwolfEnhancedGameInfoIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OWGameResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getOverwolfEnhancedGameInfoId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/overwolf/enhanced-game-info/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OWGameResponseFromJSON(jsonValue));
    }

    /**
     * Get enhanced game information including all original and Steam fields for Admin and front-end display
     */
    async getOverwolfEnhancedGameInfoId(requestParameters: GetOverwolfEnhancedGameInfoIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OWGameResponse> {
        const response = await this.getOverwolfEnhancedGameInfoIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for games with enhanced features and SEO pages
     */
    async getOverwolfEnhancedGamesSearchRaw(requestParameters: GetOverwolfEnhancedGamesSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchEnhancedGamesResponse>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['gameId'] != null) {
            queryParameters['gameId'] = requestParameters['gameId'];
        }

        if (requestParameters['seoEnabled'] != null) {
            queryParameters['seoEnabled'] = requestParameters['seoEnabled'];
        }

        if (requestParameters['timeTrackedGame'] != null) {
            queryParameters['timeTrackedGame'] = requestParameters['timeTrackedGame'];
        }

        if (requestParameters['hasEvents'] != null) {
            queryParameters['hasEvents'] = requestParameters['hasEvents'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/overwolf/enhanced-games/search`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchEnhancedGamesResponseFromJSON(jsonValue));
    }

    /**
     * Search for games with enhanced features and SEO pages
     */
    async getOverwolfEnhancedGamesSearch(requestParameters: GetOverwolfEnhancedGamesSearchRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchEnhancedGamesResponse> {
        const response = await this.getOverwolfEnhancedGamesSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get list of all game event mappings
     */
    async getOverwolfEventMappingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOverwolfEventMappingsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/overwolf/event-mappings`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOverwolfEventMappingsResponseFromJSON(jsonValue));
    }

    /**
     * Get list of all game event mappings
     */
    async getOverwolfEventMappings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOverwolfEventMappingsResponse> {
        const response = await this.getOverwolfEventMappingsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get a single event type by ID
     */
    async getOverwolfEventTypeIdRaw(requestParameters: GetOverwolfEventTypeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OWEventType>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getOverwolfEventTypeId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/overwolf/event-type/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OWEventTypeFromJSON(jsonValue));
    }

    /**
     * Get a single event type by ID
     */
    async getOverwolfEventTypeId(requestParameters: GetOverwolfEventTypeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OWEventType> {
        const response = await this.getOverwolfEventTypeIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get list of all event types
     */
    async getOverwolfEventTypesRaw(requestParameters: GetOverwolfEventTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOverwolfEventTypesResponse>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['game'] != null) {
            queryParameters['game'] = requestParameters['game'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['numberOfAvailableOffsets'] != null) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters['numberOfAvailableOffsets'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/overwolf/event-types`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOverwolfEventTypesResponseFromJSON(jsonValue));
    }

    /**
     * Get list of all event types
     */
    async getOverwolfEventTypes(requestParameters: GetOverwolfEventTypesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOverwolfEventTypesResponse> {
        const response = await this.getOverwolfEventTypesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get list of all event types without pagination
     */
    async getOverwolfEventTypesAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAllOverwolfEventTypesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/overwolf/event-types/all`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAllOverwolfEventTypesResponseFromJSON(jsonValue));
    }

    /**
     * Get list of all event types without pagination
     */
    async getOverwolfEventTypesAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAllOverwolfEventTypesResponse> {
        const response = await this.getOverwolfEventTypesAllRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns a lightweight name→iconUrl entry for every game/category we can icon: platform box art first (Twitch Helix box_art_url / Kick category thumbnail, resolved by streamed gameId then by name for Drop.games[] strings with no recorded id), with curated OWGame catalog assets as the fallback for names neither platform resolves. Backs the Drop-In directory\'s game-icon lookup. The assembled map is cached in GCS for 1 day and at the edge for an hour. 
     * name → iconUrl for ALL games + streamed categories (Drop-In game-icon resolution)
     */
    async getOverwolfGameIconsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GameIconsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/overwolf/game-icons`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GameIconsResponseFromJSON(jsonValue));
    }

    /**
     * Returns a lightweight name→iconUrl entry for every game/category we can icon: platform box art first (Twitch Helix box_art_url / Kick category thumbnail, resolved by streamed gameId then by name for Drop.games[] strings with no recorded id), with curated OWGame catalog assets as the fallback for names neither platform resolves. Backs the Drop-In directory\'s game-icon lookup. The assembled map is cached in GCS for 1 day and at the edge for an hour. 
     * name → iconUrl for ALL games + streamed categories (Drop-In game-icon resolution)
     */
    async getOverwolfGameIcons(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GameIconsResponse> {
        const response = await this.getOverwolfGameIconsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get list of all games
     */
    async getOverwolfGamesRaw(requestParameters: GetOverwolfGamesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOverwolfGamesResponse>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['seoFilter'] != null) {
            queryParameters['seoFilter'] = requestParameters['seoFilter'];
        }

        if (requestParameters['eventFilter'] != null) {
            queryParameters['eventFilter'] = requestParameters['eventFilter'];
        }

        if (requestParameters['steamFilter'] != null) {
            queryParameters['steamFilter'] = requestParameters['steamFilter'];
        }

        if (requestParameters['categoryFilter'] != null) {
            queryParameters['categoryFilter'] = requestParameters['categoryFilter'];
        }

        if (requestParameters['tournamentFilter'] != null) {
            queryParameters['tournamentFilter'] = requestParameters['tournamentFilter'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['numberOfAvailableOffsets'] != null) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters['numberOfAvailableOffsets'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/overwolf/games`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOverwolfGamesResponseFromJSON(jsonValue));
    }

    /**
     * Get list of all games
     */
    async getOverwolfGames(requestParameters: GetOverwolfGamesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOverwolfGamesResponse> {
        const response = await this.getOverwolfGamesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get game information by URL slug for public game pages
     */
    async getOverwolfGamesBySlugSlugRaw(requestParameters: GetOverwolfGamesBySlugSlugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OWGameResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling getOverwolfGamesBySlugSlug().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/overwolf/games/by-slug/{slug}`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OWGameResponseFromJSON(jsonValue));
    }

    /**
     * Get game information by URL slug for public game pages
     */
    async getOverwolfGamesBySlugSlug(requestParameters: GetOverwolfGamesBySlugSlugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OWGameResponse> {
        const response = await this.getOverwolfGamesBySlugSlugRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves Overwolf game data.
     */
    async getOverwolfGamesIdRaw(requestParameters: GetOverwolfGamesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OWGame>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getOverwolfGamesId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/overwolf/games/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OWGameFromJSON(jsonValue));
    }

    /**
     * Retrieves Overwolf game data.
     */
    async getOverwolfGamesId(requestParameters: GetOverwolfGamesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OWGame> {
        const response = await this.getOverwolfGamesIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves Overwolf rewards for a specific game.
     */
    async getOverwolfGamesIdRewardsRaw(requestParameters: GetOverwolfGamesIdRewardsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OWReward>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getOverwolfGamesIdRewards().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/overwolf/games/{id}/rewards`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OWRewardFromJSON));
    }

    /**
     * Retrieves Overwolf rewards for a specific game.
     */
    async getOverwolfGamesIdRewards(requestParameters: GetOverwolfGamesIdRewardsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OWReward>> {
        const response = await this.getOverwolfGamesIdRewardsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the Overwolf gameIds of platform launchers (Battle.net, Epic, Steam, etc.). The renderer uses this to suppress launcher-state flicker when a non-launcher game is the active session.
     */
    async getOverwolfGamesLaunchersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OverwolfLauncherGameIdsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/overwolf/games/launchers`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OverwolfLauncherGameIdsResponseFromJSON(jsonValue));
    }

    /**
     * Returns the Overwolf gameIds of platform launchers (Battle.net, Epic, Steam, etc.). The renderer uses this to suppress launcher-state flicker when a non-launcher game is the active session.
     */
    async getOverwolfGamesLaunchers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OverwolfLauncherGameIdsResponse> {
        const response = await this.getOverwolfGamesLaunchersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get list of all event types
     */
    async getOverwolfQuestsRaw(requestParameters: GetOverwolfQuestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOverwolfQuestsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['game'] != null) {
            queryParameters['game'] = requestParameters['game'];
        }

        if (requestParameters['isActive'] != null) {
            queryParameters['isActive'] = requestParameters['isActive'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['numberOfAvailableOffsets'] != null) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters['numberOfAvailableOffsets'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/overwolf/quests`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOverwolfQuestsResponseFromJSON(jsonValue));
    }

    /**
     * Get list of all event types
     */
    async getOverwolfQuests(requestParameters: GetOverwolfQuestsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOverwolfQuestsResponse> {
        const response = await this.getOverwolfQuestsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves Overwolf user stats.
     */
    async getOverwolfUserStatsRaw(requestParameters: GetOverwolfUserStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUserStatsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['gameId'] != null) {
            queryParameters['gameId'] = requestParameters['gameId'];
        }

        if (requestParameters['rewardId'] != null) {
            queryParameters['rewardId'] = requestParameters['rewardId'];
        }

        if (requestParameters['rewardCategory'] != null) {
            queryParameters['rewardCategory'] = requestParameters['rewardCategory'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/overwolf/user-stats`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUserStatsResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves Overwolf user stats.
     */
    async getOverwolfUserStats(requestParameters: GetOverwolfUserStatsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUserStatsResponse> {
        const response = await this.getOverwolfUserStatsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets the total xp, time and played games of the current user.
     */
    async getOverwolfUserSummaryRaw(requestParameters: GetOverwolfUserSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUserSummaryResponse>> {
        const queryParameters: any = {};

        if (requestParameters['period'] != null) {
            queryParameters['period'] = requestParameters['period'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/overwolf/user-summary`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUserSummaryResponseFromJSON(jsonValue));
    }

    /**
     * Gets the total xp, time and played games of the current user.
     */
    async getOverwolfUserSummary(requestParameters: GetOverwolfUserSummaryRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUserSummaryResponse> {
        const response = await this.getOverwolfUserSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves Overwolf-related account experience transactions for a user.
     */
    async getOverwolfXpRaw(requestParameters: GetOverwolfXpRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOverwolfXPResponse>> {
        if (requestParameters['subject'] == null) {
            throw new runtime.RequiredError(
                'subject',
                'Required parameter "subject" was null or undefined when calling getOverwolfXp().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['overwolfRewardId'] != null) {
            queryParameters['overwolfRewardId'] = requestParameters['overwolfRewardId'];
        }

        if (requestParameters['gameId'] != null) {
            queryParameters['gameId'] = requestParameters['gameId'];
        }

        if (requestParameters['subject'] != null) {
            queryParameters['subject'] = requestParameters['subject'];
        }

        if (requestParameters['notes'] != null) {
            queryParameters['notes'] = requestParameters['notes'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/overwolf/xp`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOverwolfXPResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves Overwolf-related account experience transactions for a user.
     */
    async getOverwolfXp(requestParameters: GetOverwolfXpRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOverwolfXPResponse> {
        const response = await this.getOverwolfXpRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to update existing Overwolf event type
     */
    async updateOverwolfEventTypeIdRaw(requestParameters: UpdateOverwolfEventTypeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OWEventTypeResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateOverwolfEventTypeId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/overwolf/event-type/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OWEventTypeBodyToJSON(requestParameters['oWEventTypeBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OWEventTypeResponseFromJSON(jsonValue));
    }

    /**
     * Used to update existing Overwolf event type
     */
    async updateOverwolfEventTypeId(requestParameters: UpdateOverwolfEventTypeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OWEventTypeResponse> {
        const response = await this.updateOverwolfEventTypeIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to update existing Overwolf game
     */
    async updateOverwolfGamesIdRaw(requestParameters: UpdateOverwolfGamesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateOverwolfGamesId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/overwolf/games/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOverwolfGameBodyToJSON(requestParameters['createOverwolfGameBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used to update existing Overwolf game
     */
    async updateOverwolfGamesId(requestParameters: UpdateOverwolfGamesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateOverwolfGamesIdRaw(requestParameters, initOverrides);
    }

    /**
     * Used to update existing Overwolf game images
     */
    async updateOverwolfGamesIdImagesRaw(requestParameters: UpdateOverwolfGamesIdImagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateOverwolfGamesIdImages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/overwolf/games/{id}/images`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOverwolfGameImagesToJSON(requestParameters['createOverwolfGameImages']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used to update existing Overwolf game images
     */
    async updateOverwolfGamesIdImages(requestParameters: UpdateOverwolfGamesIdImagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateOverwolfGamesIdImagesRaw(requestParameters, initOverrides);
    }

    /**
     * Used to update existing Overwolf quest (OWReward doc)
     */
    async updateOverwolfQuestIdRaw(requestParameters: UpdateOverwolfQuestIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OWQuestResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateOverwolfQuestId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/overwolf/quest/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OWQuestBodyToJSON(requestParameters['oWQuestBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OWQuestResponseFromJSON(jsonValue));
    }

    /**
     * Used to update existing Overwolf quest (OWReward doc)
     */
    async updateOverwolfQuestId(requestParameters: UpdateOverwolfQuestIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OWQuestResponse> {
        const response = await this.updateOverwolfQuestIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Dismiss the weekly limit feedback for the user\'s Overwolf reward stats.
     */
    async updateOverwolfWeeklyLimitFeedbackRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/overwolf/weekly-limit-feedback`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Dismiss the weekly limit feedback for the user\'s Overwolf reward stats.
     */
    async updateOverwolfWeeklyLimitFeedback(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateOverwolfWeeklyLimitFeedbackRaw(initOverrides);
    }

}

/**
 * @export
 */
export const GetOverwolfEnhancedGamesSearchSeoEnabledEnum = {
    True: 'true',
    False: 'false'
} as const;
export type GetOverwolfEnhancedGamesSearchSeoEnabledEnum = typeof GetOverwolfEnhancedGamesSearchSeoEnabledEnum[keyof typeof GetOverwolfEnhancedGamesSearchSeoEnabledEnum];
/**
 * @export
 */
export const GetOverwolfEnhancedGamesSearchTimeTrackedGameEnum = {
    True: 'true',
    False: 'false'
} as const;
export type GetOverwolfEnhancedGamesSearchTimeTrackedGameEnum = typeof GetOverwolfEnhancedGamesSearchTimeTrackedGameEnum[keyof typeof GetOverwolfEnhancedGamesSearchTimeTrackedGameEnum];
/**
 * @export
 */
export const GetOverwolfEnhancedGamesSearchHasEventsEnum = {
    True: 'true',
    False: 'false'
} as const;
export type GetOverwolfEnhancedGamesSearchHasEventsEnum = typeof GetOverwolfEnhancedGamesSearchHasEventsEnum[keyof typeof GetOverwolfEnhancedGamesSearchHasEventsEnum];
/**
 * @export
 */
export const GetOverwolfGamesSeoFilterEnum = {
    All: 'all',
    Enabled: 'enabled',
    Disabled: 'disabled'
} as const;
export type GetOverwolfGamesSeoFilterEnum = typeof GetOverwolfGamesSeoFilterEnum[keyof typeof GetOverwolfGamesSeoFilterEnum];
/**
 * @export
 */
export const GetOverwolfGamesEventFilterEnum = {
    All: 'all',
    Events: 'events',
    Time: 'time'
} as const;
export type GetOverwolfGamesEventFilterEnum = typeof GetOverwolfGamesEventFilterEnum[keyof typeof GetOverwolfGamesEventFilterEnum];
/**
 * @export
 */
export const GetOverwolfGamesSteamFilterEnum = {
    All: 'all',
    Has: 'has',
    None: 'none'
} as const;
export type GetOverwolfGamesSteamFilterEnum = typeof GetOverwolfGamesSteamFilterEnum[keyof typeof GetOverwolfGamesSteamFilterEnum];
/**
 * @export
 */
export const GetOverwolfGamesTournamentFilterEnum = {
    All: 'all',
    Supported: 'supported',
    Unsupported: 'unsupported'
} as const;
export type GetOverwolfGamesTournamentFilterEnum = typeof GetOverwolfGamesTournamentFilterEnum[keyof typeof GetOverwolfGamesTournamentFilterEnum];
/**
 * @export
 */
export const GetOverwolfUserStatsRewardCategoryEnum = {
    Event: 'EVENT',
    Time: 'TIME'
} as const;
export type GetOverwolfUserStatsRewardCategoryEnum = typeof GetOverwolfUserStatsRewardCategoryEnum[keyof typeof GetOverwolfUserStatsRewardCategoryEnum];
/**
 * @export
 */
export const GetOverwolfUserSummaryPeriodEnum = {
    Today: 'today',
    Weekly: 'weekly',
    Monthly: 'monthly',
    AllTime: 'allTime'
} as const;
export type GetOverwolfUserSummaryPeriodEnum = typeof GetOverwolfUserSummaryPeriodEnum[keyof typeof GetOverwolfUserSummaryPeriodEnum];
/**
 * @export
 */
export const GetOverwolfXpSubjectEnum = {
    OverwolfTimeReward: 'OVERWOLF_TIME_REWARD',
    OverwolfEventReward: 'OVERWOLF_EVENT_REWARD',
    OverwolfTimeQuestReward: 'OVERWOLF_TIME_QUEST_REWARD'
} as const;
export type GetOverwolfXpSubjectEnum = typeof GetOverwolfXpSubjectEnum[keyof typeof GetOverwolfXpSubjectEnum];
